import React from "react";
import { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Glyphicon} from "react-bootstrap";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import SDKSidebar from "js/utilities/sdk-sidebar";

import CUSTOM_HEADER_SWIFT from "resources/code/ios/20-custom-string.swift.tpl";
import CUSTOM_HEADER_JAVA from "resources/code/android/21-custom-string.java.tpl"
import CUSTOM_ACCESSIBILITY_JAVA from "resources/code/android/38-customization-accessibility.java.tpl";
import LOCALIZATION_SETLANGUAGE_JAVA from "resources/code/android/22-localization-setlanguage.java.tpl"
import LOCALIZATION_SETLANGUAGE_SWIFT from "resources/code/ios/21-localization-setlanguage.swift.tpl";
import LOCALIZATION_SETLANGUAGE_OBJC from "resources/code/ios/21-localization-setlanguage.m.tpl";
import LOCALIZATION_TABLE_SWIFT from "resources/code/ios/configure-localization.swift.tpl";
import LOCALIZATION_TABLE_OBJC from "resources/code/ios/configure-localization.m.tpl";
import ZOOM_LOCALIZATION_LOAD_JS from "resources/code/web/quickstart/localization-load-example.html.tpl";
import ZOOM_LOCALIZATION_CALL_API from "resources/code/web/quickstart/localization-call-api.js.tpl";
import ZOOM_CUSTOM_RESOURCES from "resources/code/web/quickstart/custom-resources.html.tpl";

export default React.createClass({
  scrollToGuide : null,
  scrollingEl: null,
  displayName: "string-customization-guide",
  getInitialState: function() {
    var data  = [
        ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data,
      error: "",
      loading: false,
      complete: false,
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },
  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="string-customization">Text & Language Editing</h2>
                </div>
                <p>Learn how to customize and localize any piece of text/string in the FaceTec Interface, and how to localize FaceTec SDKs to the languages that you support.</p>
                <hr/>
              </section>

              <section>
                <h3 id="introduction">Introduction</h3>
                <p>Developers can customize and localize any text from any screen in the FaceTec Interface.</p>
                <p>Each Device SDK contains a "Strings File" that can be used as a baseline for customizing the default strings in the app.  The Strings File can also be duplicated and conditionally deployed for different locales and languages.</p>
                <p>For example, to modify the I'm Ready Button text on the Guidance Screens, search for the string name "zoom_action_continue" and insert your customized message:</p>
                <div className="code-container">
                  <CodeBlocks strings={CUSTOM_HEADER_SWIFT()} xml={CUSTOM_HEADER_JAVA()}/>
                </div>
              </section>

              <hr />

              <section>
                <h3 id="localization">Localization</h3>

                <p>For iOS and Android, FaceTec supports localization through standard System Settings. Just add the specific string resource files with your translated values and allow the FaceTec SDK to be presented to the Users in their desired system locale.</p>
                <p>For Browser, FaceTec supports localization via a template JS file that should be loaded at page load time in your HTML or dynamically at runtime by using the <code>configureLocalization</code> API.</p>

                <p><h4>Android</h4></p>
                <p>To get started, copy the string resource file provided with the latest FaceTec release package and add it to a new locale-specific folder under Resources. Then, edit each value to your desired language. For example, if your application's default language is English and you are localizing text to French, each <code>strings.xml</code> resource file should be stored in a locale-specific resource directory like follows:</p>
                <ol>
                  <li><p><code>res/values/strings.xml</code> contains English text for all default values.</p></li>
                  <li><p><code>res/values-fr/strings.xml</code> contains French text for all translatable strings.</p></li>
                </ol>

                <p>Android supports customization of Accessibility TalkBack for the FaceTec SDK Cancel Button. Search for the string name "zoom_accessibility_cancel_button" and insert your customized message for TalkBack to read:</p>
                <div className="code-container">
                  <CodeBlocks xml={CUSTOM_ACCESSIBILITY_JAVA()}/>
                </div>

                <h4>iOS</h4>
                <p>To get started, include the string resource file named <code>Zoom.strings</code> provided with the latest FaceTec release package to your project's Resources folder. This file name is required and customization will only work if set as specified. Next, navigate to <code>Project Settings → Info</code> and in the <code>Localizations</code> section add your desired language, making sure to include <code>Zoom.strings</code> as a Resource File. This way, when the User has their device's System Language set to a language supported by your application, FaceTec SDKs will utilize the appropriate string resources. </p>
                <p>Optionally, you may specify a different string table and bundle instance to search in. If you would like to do this, use the  <code>configureLocalizationWithTable</code> function, as demonstrated below:</p>
                <div className="code-container">
                  <CodeBlocks swift={LOCALIZATION_TABLE_SWIFT()} objC={LOCALIZATION_TABLE_OBJC()} />
                </div>

                <h4>Browser</h4>
                <p>To get started, copy the JS file named <code>ZoomStrings.js</code> provided with the latest FaceTec release package to your project's folder. We recommend renaming this file to <code>ZoomStrings.en.js</code> where en represents the desired localization code. Make sure this script is loaded before ZoomAuthentication.js. Now you can redefine any strings in FaceTec SDKs with the appropriate translated values.</p>
                <div className="code-container">
                  <CodeBlocks js={ZOOM_LOCALIZATION_LOAD_JS()}/>
                </div>
                <p>To override the default strings, use the <code>configureLocalization</code> function, as shown below.</p>
                <div className="code-container">
                  <CodeBlocks js={ZOOM_LOCALIZATION_CALL_API()}/>
                </div>
                <p>Now you can redefine every string in                 <p>To get started, copy the JS file named <code>ZoomStrings.js</code> provided with the latest FaceTec release package to your project's folder. We recommend renaming this file to <code>ZoomStrings.en.js</code> where en represents the desired localization code. Make sure this script is loaded before ZoomAuthentication.js. Now you can redefine any strings in FaceTec SDKs with the appropriate translated values.</p>
 with the appropriate translated values and your application will load following the User's device locale.</p>
                <blockquote>
                  <p><strong>Note</strong>: <code>configureLocalization</code> MUST BE called after initialize() or initializeWithLicense(). For more information on localizing your application and best practices, please see the official documentation for <a href="https://developer.apple.com/library/content/documentation/MacOSX/Conceptual/BPInternational/Introduction/Introduction.html#//apple_ref/doc/uid/10000171i-CH1-SW1" target="_blank">iOS</a> and <a href="https://developer.android.com/guide/topics/resources/localization.html" target="_blank">Android</a>.</p>
                </blockquote>
              </section>

              <hr/>
              <section>
                <h3 id="overriding-system-settings">Overriding System Settings</h3>
                <p>Alternatively to manually redefining strings, developers can modify the device's locale information and alter how the application retrieves resources. This way, FaceTec SDKs will the specified locale to the User, regardless of device's settings.</p>
                <p>For iOS and Android, this process overrides the User's locale and can create inconsistencies. For more information and best practices, refer to the official Android documentation on <a href="https://developer.android.com/guide/topics/resources/multilingual-support.html" target="_blank">Locale</a> and <a href="https://developer.android.com/reference/android/content/res/Configuration.html" target="_blank">Configuration</a>, or the official Apple documentation on <a href="https://developer.apple.com/library/content/documentation/MacOSX/Conceptual/BPInternational/Introduction/Introduction.html#//apple_ref/doc/uid/10000171i-CH1-SW1" target="_blank">Language and Locale IDs</a>.</p>
                <p><strong>Android:</strong></p>
                <p>After setting up the appropriate locale-specific resource folders, retrieve the base application's configuration and call <code>setLocale</code> with a valid Language ID as argument. Next, just update the current configuration and refresh the application to reflect the new locale. For example, to set your application's locale to French:</p>
                <div className="code-container">
                  <CodeBlocks java={LOCALIZATION_SETLANGUAGE_JAVA()}/>
                </div>
                <p><strong>iOS:</strong></p>
                <p>The <code>setLanguage</code> function gives you the ability to override the User's preferences with a specific locale. To use it, call the <code>setLanguage</code> function with a valid Language ID as argument. For example, to set your application's locale to French:</p>
                <div className="code-container">
                  <CodeBlocks swift={LOCALIZATION_SETLANGUAGE_SWIFT()} objC={LOCALIZATION_SETLANGUAGE_OBJC()} />
                </div>
                <p>For a list of valid Locale IDs and how to use language and region designators appropriately, please see the official Apple documentation <a href="https://developer.apple.com/library/content/documentation/MacOSX/Conceptual/BPInternational/LanguageandLocaleIDs/LanguageandLocaleIDs.html" target="_blank">here</a>.</p>
                <p></p>
              </section>

              <hr/>
              <section>
                <h3 id="customizing-resources">Customizing FaceTec Resources Directory (Browser Only)</h3>
                <p>By default, the FaceTec Browser SDK loads resource files from <code>ZoomAuthentication.js/resources</code>.  These resource files include css, js, and wasm files.</p>
                <p>You may specify a different, custom directory to load FaceTec resources from if you would like.  If you choose to do this, you must host all resources exactly as they are found in the original resources directory.  Modification of any of these resources is <strong>not allowed</strong>. This directory must be a descendant of your root directory.</p>
                <p>To specify a custom directory, add the following to your code after loading ZoomAuthentication.js and before  <code>ZoomSDK.initialize()</code>. For example, in the body of your <code>index.html</code> file:</p>
                <div className="code-container">
                  <CodeBlocks js={ZOOM_CUSTOM_RESOURCES()}/>
                </div>
              </section>

              <SDKSidebar menuType="main" title="String-Customization-Guide"/>

            </div>
          </div>
        </div>
      </div>
    );
  }

});



// WEBPACK FOOTER //
// ./src/js/components/screens/string-customization-guide.jsx